import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'customCurrency' })
export class CustomCurrencyPipe implements PipeTransform {
    userLang = localStorage.getItem('userLang') || 'en';
    transform(value: number): string {
        const isInteger = Number.isInteger(value);
        return isInteger ? `${value}` : `${value.toLocaleString(this.userLang, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
}